module.exports = __webpack_public_path__ + "static/media/novasports.36866036.png";